<template src="./DeliveryDataComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, onMounted, computed, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";

export default {
  name: 'DeliveryDataComponent',
  components: {
    InputDateTimeNormal,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const dataHeaderTable = ref({
      exchange_delivery_name: {
        label: 'Dữ liệu giao hàng',
        order: 1,
        width: '25%',
      },
      store_id: {
        label: 'Cửa hàng',
        order: 2,
        width: '15%',
      },
      companyNameReceiver: {
        label: 'Đối tác',
        order: 3,
        width: '25%',
      },
      timeCreated: {
        label: 'Ngày tạo',
        order: 4,
        width: '15%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo dữ liệu giao hàng')
    const urlOrigin = ref('/v1/m-deliveries/store-master-deliveries/')
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const dataSearch = ref({
      exchange_delivery_name: {
        id: 'exchange_delivery_name',
        label: 'Dữ liệu giao hàng',
        placeholder: 'Tên dữ liệu giao hàng',
        value: ''
      },
      partner_name: {
        id: 'partner_name',
        label: 'Tên công ty',
        placeholder: 'Tên công ty',
        value: ''
      },
      partner_code: {
        id: 'partner_code',
        label: 'Mã công ty',
        placeholder: 'Mã công ty',
        value: ''
      },
      time_created: {
        id: 'time_created',
        label: 'Ngày tạo',
        placeholder: 'Ngày tạo',
        value: ''
      },
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: ''
      },
    })
    const deliveryStore = useDeliveryStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      getListDeliveries(router.currentRoute.value.query.page ?? 1);
    });

    watch(() => deliveryStore.masterDeliveries, (newListDeliveries) => {
      newListDeliveries.forEach((delivery) => {
        if(checkItems.value[delivery.id] === undefined) {
          checkItems.value[delivery.id] = false
        }
      })
    });

    const listDeliveries = computed(() => {
      return deliveryStore.masterDeliveries;
    });
    const paginate = computed(() => {
      return deliveryStore.paginate;
    });
    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function emitPage(page) {
      getListDeliveries(page);
    }

    function redirectToCreate() {
      router.push('/delivery-data/create')
    }

    function getListDeliveries(page) {
      const params = {
        company_id: accountStore.account.company.id,
        exchange_delivery_name: dataSearch.value.exchange_delivery_name.value,
        partner_name: dataSearch.value.partner_name.value,
        partner_code: dataSearch.value.partner_code.value,
        store_id: dataSearch.value.store_id.value,
        page: page,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/m-deliveries/store-master-deliveries';
      deliveryStore.getListMasterDeliveries(url, params);
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listDeliveries.value.forEach((item) => {
          if(listItemSelected.value.indexOf(item.id) === -1) {
            listItemSelected.value.push(item.id)
          }
        })
      }
    }
    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listDeliveries.value.forEach((item) => {
        if(checkItems.value[item.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(item.id) === -1 && parseInt(name) === parseInt(item.id)) {
          listItemSelected.value.push(item.id)
        }else if (!value && listItemSelected.value[item.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(item.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listDeliveries.value.length) {
        checkAll.value = true
      }
    }

    function searchDeliveries() {
      getListDeliveries(1);
    }

    function showDeliveryDetail(deliveryId) {
      router.push('/delivery-data/detail/' + deliveryId)
    }

    return {
      listDeliveries,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      checkItems,
      emitPage,
      redirectToCreate,
      onChange,
      searchDeliveries,
      onChangeSelectAll,
      onChangeSelectItem,
      showDeliveryDetail,
      CommonService
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);

      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .btn-create-data {
          width: 200px;
          margin-top: 50px;
        }

        .list-partners-component {
          margin-top: 30px;

          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.delivery-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
